<template>
    <div class="post">
        <div class="post--hero">
            <div class="post--hero--image"><img v-if="post.featuredMedia" :src="post.featuredMedia.src" /></div>
            <div class="post--hero--content">
                <b-container>
                    <div class="post--hero--wrapper">
                        <h3 class="post--hero--title">{{post.title}}</h3>
                        <!--
                        <div class="post--hero--date">{{post.readableDate}}</div>
                        <div class="post--hero--cta">
                            <button-with-icon
                                variant="cta"
                                text="Torna indietro"
                                :icon="chevron_right"
                                :clicked="() => {
                                    router.go(-1)
                                }"
                            />
                        </div>-->
                        <!--
                        <div class="post--hero--date">
                            Scopri in pochi click le soluzioni prenotabili sul nostro sito!
                        </div>-->
                        <div class="post--hero--cta">
                            <button-with-icon
                                variant="cta"
                                text="INIZIA QUI!"
                                :clicked="() => {
                                    this.$bvModal.show('request-modal')
                                }"
                            />
                        </div>                        
                        <b-modal id="request-modal" title="Organizza il tuo viaggio" size="xl" hide-footer>
                            <request-send-access-link custom_event_action="storyTop"/>
                        </b-modal>
                    </div>
                </b-container>
            </div>
        </div>

        <b-container fluid>
            <div class="panel">
                <div class="post--content" v-html="post.content"></div>
                <request-send-access-link custom_event_action="storyBottom" />
            </div>          
        </b-container>

    </div>
</template>

<script>
    import { posts } from '@/api'
    import Router from '@/router'
    import Bwi from '@/components/atoms/button-with-icon'
    import { chevron_right } from '@/components/svg/chevrons'
    import RequestSendAccessLink from '@/components/blocks/request-send-access-link'

    export default {
        name: 'post',
        metaInfo () {
          return {
            title: (this.post.title)? this.post.title : 'post',
            meta: [
              { vmid: 'robots', name: 'robots', content: this.metaRobots },

              (this.post.title)?{ vmid: 'metaTitle', name: 'Title', content: this.post.title } : {},

              (this.post.excerpt)?{ vmid: 'metaDescription', name: 'Description', content: this.post.excerpt } : {},

              (this.post.title)?{ vmid: 'ogTitle', name: 'og:title', content: this.post.title } : {},

              (this.post.excerpt)?{ vmid: 'ogDescription', name: 'og:description', content: this.post.excerpt } : {},

              (this.post.featuredMedia)? { vmid: 'ogImage', name: 'og:image', content: this.post.featuredMedia.src } : {},

              (this.post.featuredMedia)? { vmid: 'ogImageWidth', name: 'og:width', content: this.post.featuredMedia.width } : {},

              (this.post.featuredMedia)? { vmid: 'ogImageHeight', name: 'og:height', content: this.post.featuredMedia.height } : {},

            ]
          }
        },
        components: {
            'button-with-icon': Bwi,
            'request-send-access-link': RequestSendAccessLink,
        },
        props: {
            post_id: String,
        },
        data() {
            return {
                post: {}
            }
        },
        computed: {
        },
        created()
        {
            this.router = Router
            this.chevron_right = chevron_right            
        },
        mounted() {
            posts({
                postId: this.post_id,
                asArray: true,
            })
                .then(response => {
                    this.post = response.posts[0]
                })
        },
        methods:{
        },
    }
</script>

<style lang="scss">
.post
{
    blockquote
    {
        color:$primary;
        font-size: 1.5rem;
        text-align: center;
        margin:2.5rem auto;
        p
        {
            margin-bottom: 0;
            display: inline-block;
            &:after,
            &:before
            {
                font-size: 140%;
                margin:0 8px;
                line-height: 1;
            }
            &:after
            {
                content: '\201D';
            }
            &:before
            {
                content: '\201C';
            }
        }
    }
}
</style>